var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-typing-indicator",style:(_vm.messageColors)},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }